// extracted by mini-css-extract-plugin
module.exports = {"ticketContainer":"Report_ticketContainer__tedTb","bottomContainer":"Report_bottomContainer__UjXxo","heading":"Report_heading__3pM7h","bottomButton":"Report_bottomButton__1rHAp"};